import { put, takeLatest } from 'redux-saga/effects';
import {
  appNotify,
  setSelectedGroupIsLoading,
  setCustomShapes,
  setSelectedCustomShape,
  setSelectedGroup,
  setSelectedGroupId,
  setMapIsLoading,
} from '../../../store/actions';
import { getWithToken } from '../../../api/network';

export function* fetchAssumptionGroupSaga() {
  yield takeLatest(setSelectedGroupId, function* ({ payload }) {
    try {
      if (!payload.selectedGroupId) {
        yield put(setSelectedGroup(null));
        return;
      }

      yield put(setSelectedGroupIsLoading(true));

      const url = `/api/assumptions/groups/${payload.selectedGroupId}`;
      const res = yield getWithToken(url);
      const data = yield res.json();

      yield put(setSelectedGroup(data));
      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(true, 'SHAPES', 'Loading Custom Shapes...'));

      const shapesUrl = `/api/assumptions/shapes/coordinates?groupId=${payload.selectedGroupId}`;
      const shapesRes = yield getWithToken(shapesUrl);
      const shapesData = yield shapesRes.json();

      yield put(setCustomShapes(shapesData));

      if (payload.selectedCustomShapeId) {
        yield put(setSelectedCustomShape(payload.selectedCustomShapeId));
      } else if (shapesData && shapesData.length > 0) {
        yield put(setSelectedCustomShape(shapesData[0].shapeId));
      }

      yield put(setMapIsLoading(false, 'SHAPES'));
    } catch (error) {
      yield put(
        appNotify(
          `Failure in fetchAssumptionGroupSaga: ${error.message}`,
          'error'
        )
      );
      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(false, 'SHAPES'));
    }
  });
}
